module.exports = __webpack_public_path__ + "static/img/daiyunying_10.d1eea6db.jpg";